<template>
  <!-- <v-container> -->
  <div>
    <div>
      <!-- <div>PROPERTY DAMAGE HELPER</div> -->
    </div>
    <v-expand-transition>
      <v-form
        class="ma-2 pa-2"
        @submit.prevent="singIn"
        ref="form"
        v-if="!user"
      >
        <div>
          <v-card
            outlined
            rounded
            class="ma-auto"
            max-width="600px"
            style="border-radius: 26px; border: 1px solid #64B5F6"
          >
            <v-progress-circular
              color="green"
              v-if="overlay == true"
              indeterminate
            ></v-progress-circular>
            <v-card-text
              class="text-center font-weight-bold subtitle-1 ma-auto"
            >
              PLEASE INPUT THE FOLLOWING INFORMATION AND CONTINUE
            </v-card-text>
            <!-- <v-form @submit.prevent="onContinue"> -->
            <v-form>
              <v-container fluid>
                <v-text-field
                  v-model="firstName"
                  label="FIRST NAME (REQUIRED)"
                  color="#2979FF"
                  autofocus
                  style="max-width: 500px"
                  class="ma-auto mb-1"
                  clearable
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="lastName"
                  label="LAST NAME (REQUIRED)"
                  color="#2979FF"
                  style="max-width: 500px"
                  class="ma-auto mb-1"
                  clearable
                  outlined
                  dense
                ></v-text-field>

                <v-text-field
                  v-model="email"
                  label="EMAIL:"
                  color="#2979FF"
                  style="max-width: 500px"
                  class="ma-auto mb-1"
                  dense
                  outlined
                  :rules="[rules.email]"
                ></v-text-field>
                <v-text-field
                  v-model="phone"
                  label="PHONE NUMBER:"
                  color="#2979FF"
                  style="max-width: 500px"
                  class="ma-auto mb-1"
                  hint="(###) ###-####"
                  v-mask="phoneMask"
                  dense
                  outlined
                ></v-text-field>
                <v-card
                  style="border-radius: 26px; border: 1px solid #2979FF; "
                  outlined
                  tile
                  rounded
                  class="ma-auto"
                  dense
                  max-width="500px"
                >
                  <v-card-text
                    class="text-center font-weight-bold subtitle-2 ma-auto"
                  >
                    LOSS ADDRESS (REQUIRED)
                  </v-card-text>
                  <v-text-field
                    v-model="streetAddress"
                    label="STREET ADDRESS"
                    color="#2979FF"
                    style="max-width: 400px"
                    class="ma-auto mb-1"
                    hint="123 Apple St. #4"
                    dense
                    outlined
                  ></v-text-field>
                  <v-checkbox
                    v-model="wildFire"
                    label="THIS IS A WILDFIRE MATTER"
                    color="#2979FF"
                    style="max-width: 400px"
                    class="ma-auto mb-1"
                    dense
                    outlined
                  ></v-checkbox>
                </v-card>
              </v-container>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-center ma-auto">
                <v-btn
                  oulined
                  rounded
                  color="green"
                  :disabled="!streetAddress"
                  @click="signIn"
                  id="sign-in-button"
                  >CONTINUE</v-btn
                >
              </div>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </div>
      </v-form>
    </v-expand-transition>
    <v-expand-transition>
      <!-- <contents-stepper v-if="user" :matter="matter"></contents-stepper> -->
      <!-- <contents-stepper-2 v-if="user" :matter="matter"></contents-stepper-2> -->
      <contents-stepper-3 v-if="user" :matter="matter"></contents-stepper-3>
    </v-expand-transition>
    <!-- </v-container> -->
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import slugify from "slugify";

import firebase from "firebase";
export default {
  directives: {
    mask
  },
  data: () => ({
    overlay: false,
    firstName: null,
    lastName: null,
    fullName: null,
    email: null,
    phone: null,
    streetAddress: null,
    phoneMask: "(###) ###-####",
    dateMask: "##/##/####",
    tiers: ["TOP", "MID", "STANDARD"],
    // contentsList: null,
    matter: null,
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    },
    wildFire: false
  }),
  methods: {
    async signIn() {
      this.overlay = true;
      let propertySlug = await slugify(this.streetAddress, {
        replacement: "-",
        remove: /[$*_+~.()'"!\-:@,#]/g,
        lower: true
      });
      let nameAndPhone =
        (await this.firstName.trim()) +
        " " +
        this.lastName.trim() +
        " " +
        this.phone;

      let finalLastName = await slugify(this.lastName, {
        replacement: "_",
        remove: /[$*_+~.()'"!\-:@,]/g,
        lower: true
      });
      //if email not valid create one
      if (
        this.email !== null &&
        this.email !== undefined &&
        this.email !== ""
      ) {
        console.log("email is not null");
      } else {
        console.log("email is null");
        this.email =
          this.firstName.trim().toLowerCase() +
          "." +
          finalLastName.trim().toLowerCase() +
          "@taplaw.com";
      }

      let uid = await slugify(nameAndPhone, {
        replacement: "-",
        remove: /[$*_+~.()'"!\-:@,]/g,
        lower: true
      });
      let matterID = uid + "-" + propertySlug;
      // console.log(propertySlug);
      await this.$store.dispatch("setPropertySlug", propertySlug);
      //set propertySlug in state

      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.phone)
        .then(() => {
          // Signed in..
          console.log("signed in");
          //get property information
          this.$router.push(`/contents-list/${matterID}`);
          /*TODO ******* MUST EVENTUALLY ADD TEH USER ID 
          SO I KNOW WHICH OWNER IS MAKING CHANGES
          */
          // this.$router.push(`/contents-list/${propertySlug}/${someid}`);
          //if existing pull up items list
          firebase
            .firestore()
            .collection("fireMatters")
            .doc(matterID)
            .get()
            .then(doc => {
              console.log("checking if matter exists");
              if (doc.exists) {
                // console.log("Document data:", doc.data());
                let data = doc.data();
                if (data.ownerList.includes(this.email)) {
                  this.matter = doc.data();
                } else {
                  alert("wrong property address");
                  this.$router.push("/contents-list");
                  this.$store.dispatch("logout");
                }
              } else {
                // doc.data() will be undefined in this case
                // console.log("No such document!");
                // alert("No such document!");
                console.log("no such document");
                // this.$router.push("/contents-list");
                //CREATE A NEW MATTER
              }
            })
            .catch(e => {
              console.log(e);
            });

          //if not existing create new property
        })
        .catch(error => {
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
          console.log(error);
          console.log(errorCode);
          console.log(errorMessage);
          console.log("creating new user");
          const createNewClientAdmin = firebase
            .functions()
            .httpsCallable("createNewClientAdmin");
          let firmSlug = slugify("Engstrom, Lipscomb & Lack", {
            replacement: "-",
            remove: /[$*_+~.()'"!\-:@,]/g,
            lower: true
          });
          let newClient = {
            matterID: matterID,
            propertySlug: propertySlug,
            email: this.email,
            password: this.phone,
            uid: uid,
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            caseID: null,
            streetAddress: this.streetAddress,
            firmName: "Engstrom, Lipscomb & Lack",
            firmAddressLine: "10100 Santa Monica Blvd, 12th Floor",
            firmCityStateZip: "Lod Angeles, CA 90067",
            firmPhone: "(310)552-3800",
            firmSlug: firmSlug,
            contentsListCompleted: false,
            user: null,
            wildFire: this.wildFire
          };
          if (this.existingList !== null) {
            newClient.existingList = true;
          }
          console.log(newClient);
          createNewClientAdmin(newClient)
            .then(res => {
              this.matter = newClient;
              console.log("response from createnewuseradmin --pushing ", res);
              // this.$router.push(`/contents-list/${matterID}`);

              firebase
                .auth()
                .signInWithEmailAndPassword(this.email, this.phone)
                .then(() => {
                  // Signed in..
                  console.log("signed in");
                  this.overlay = false;
                  //get property information
                  this.$router.push(`/contents-list/${matterID}`);
                })
                .catch(e => {
                  console.log(e);
                  console.log("error signing in");
                });
            })
            .catch(e => {
              console.log(e);
              console.log("error creating new user");
            });
        });
      // const phoneNumber = "+1" + this.phone;
      // console.log("phoneNumber: ", phoneNumber)
      // const appVerifier = window.recaptchaVerifier;
      // firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
      //     .then((confirmationResult) => {
      //       // SMS sent. Prompt user to type the code from the message, then sign the
      //       // user in with confirmationResult.confirm(code).
      //       const code = getCodeFromUserInput();
      //       confirmationResult.confirm(code).then((result) => {
      //         // User signed in successfully.
      //         const user = result.user;
      //         // ...
      //       }).catch((error) => {
      //         // User couldn't sign in (bad verification code?)
      //         // ...
      //       });
      //       window.confirmationResult = confirmationResult;
      //       // ...
      //     }).catch((error) => {
      //       // Error; SMS not sent
      //       // ...
      //       console.log(error)
      //     });
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
    // propertySlug() {
    //   return this.$store.getters.propertySlug;
    // },
    // contentsList() {
    //   return this.$store.getters.contentsList;
    // }
  },

  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        // console.log("user from watch", value);
        //get contents list
        // PLACE A SNAPSHOT HERE
        let matterRef = firebase
          .firestore()
          // .collection("firms")
          // .doc(newUser.firmSlug)
          .collection("fireMatters")
          .doc(value.matterID);
        matterRef.onSnapshot(res => {
          let data = res.data();
          if (data.ownerList.includes(this.user.email)) {
            this.matter = res.data();
            // console.log("matter", this.matter);
          } else {
            alert("wrong property address");
            this.$store.dispatch("logout");
          }

          // console.log("matter", this.matter);
        });
        // .then(() => {
        //   console.log("matter", this.matter);
        // })
        // .catch(e => {
        //   console.log(e);
        // });

        // firebase
        //   .firestore()
        //   .collection("matters")
        //   .doc(propertySlug)
        //   .get()
        //   .then(doc => {
        //     if (doc.exists) {
        //       console.log("Document data:", doc.data());
        //       this.matter = doc.data();
        //     } else {
        //       // doc.data() will be undefined in this case
        //       console.log("No such document!");
        //       alert("No such document!");
        //     }
        //   })
        //   .catch(e => {
        //     console.log(e);
        //   });

        // this.$store.dispatch("loadMatters", value);
        // this.$router.push('/');
        // this.$store.dispatch("getFirm", this.user.firmSlug);
      }
    }
    // matter(value) {
    //   if (value !== null && value !== undefined) {
    //     console.log("matter from watch at contentsList", value);
    //   }
    // }
  },
  created() {
    // console.log("STATE: ", this.$store.state);
    // this.$vuetify.theme.dark = false;
    // if (this.user) {
    //   this.$store.dispatch("getFirm", this.user.firmSlug);
    // }
    // console.log("matters:", this.matters);
  }
};
</script>
